<template>
  <div :class="{ 'no-border': noBorder }" class="nav-bar">
    <BlNavBarLargeMv
      v-if="isLarge"
      :title="title"
      :has-back-button="hasBackButton"
      :action-text="hasIconActionBtn ? '' : 'Bantuan CS 24 Jam'"
      :icon-list="hasIconActionBtn ? iconList : []"
      data-test-navbar-large
      class="navbar_action--auto_width"
      @handleClickActionText="handleClickActionText"
      @handleBackButtonClick="redirectToPrevPath"
    >
      <template v-slot:ico-help>
        <div
          data-test-icon-help
          test="testprops"
          @click.prevent="handleClickActionText"
        >
          <IcoHelpMinor color="active-darker" />
        </div>
      </template>
    </BlNavBarLargeMv>
    <BlNavBarMv
      v-else
      :title="title"
      :action-text="hasActionTxt ? 'Bantuan CS 24 Jam' : ''"
      :has-back-button="hasBackButton"
      :background-color="backgroundColor"
      :is-dark-mode="isDarkMode"
      data-test-navbar-normal
      class="navbar_action--auto_width"
      @handleBackButtonClick="redirectToPrevPath"
      @handleClickActionText="handleClickActionText"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import BlNavBarMv from '@bukalapak/bazaar-mweb/dist/components/BlNavBarMv';
import BlNavBarLargeMv from '@bukalapak/bazaar-mweb/dist/components/BlNavBarLargeMv';
import lakuPandaiTracker from 'shared_js/modules/tracker/lakuPandaiTracker';
import digitalTrxTrackerMixin from 'shared_features/lakupandai/mixins/digitalTrxTrackerMixin';

const IcoHelpMinor = () =>
  import(
    /* webpackChunkName: "bazaar-visual-v1/ico-help-minor" */ '@bukalapak/bazaar-visual-v1/dist/components/IcoHelpMinor'
  );

export default {
  components: {
    BlNavBarMv,
    BlNavBarLargeMv,
    IcoHelpMinor,
  },
  mixins: [digitalTrxTrackerMixin],
  props: {
    backTarget: {
      type: String,
      default: '',
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'digital-send',
    },
    customTitle: {
      type: String,
      default: null,
    },
    hasActionTxt: {
      type: Boolean,
      default: false,
    },
    hasIconActionBtn: {
      type: Boolean,
      default: false,
    },
    hasBackButton: {
      type: Boolean,
      default: true,
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    isDarkMode: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      iconList: [
        {
          name: 'help',
          link: '',
        },
      ],
    };
  },
  computed: {
    ...mapState('transaction', ['transactionId']),
    ...mapGetters('transaction', ['titlePageCopy']),
    helpUrl() {
      return 'https://wa.me/628175720770';
    },
    title() {
      if (this.customTitle === null) return this.titlePageCopy;
      return this.customTitle;
    },
  },
  methods: {
    handleClickActionText() {
      const screenNameMap = {
        DefaultError: 'error_general',
        Maintenance: 'maintenance',
        Blacklist: 'blacklist',
        KycSubmitted: 'kyc_submitted',
        TnC: 'tnc',
        NewInquiry: 'landing',
        InvalidAmount: 'landing_invalid_amount',
        PartnerOTP: 'otp',
        InvalidOTP: 'invalid_otp',
        NewTransaction: 'checkout',
        TransactionProcessed: 'confirmation',
        PhoneOTP: 'otp_request',
        PhoneOTPInput: 'otp_input',
      };
      const screenName = screenNameMap[this.$route.name];

      if (screenName) {
        this.actionTrack(screenName, 'click_help');
      }

      lakuPandaiTracker.trackEvent({
        action: 'navbar-bantuan-clicked',
      });

      window.location.assign(this.helpUrl);
    },
    redirectToPrevPath() {
      const backTarget = this.backTarget || this.$route.query.backTarget || '';
      if (backTarget === 'home') {
        window.location.assign(window.APP.mHost);
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@bukalapak/bazaar-token2/dist/tokens.scss';

.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: #ffffff;
  border-bottom: 1px solid $gray-10;

  &.no-border {
    border-bottom: none;
  }
}

.navbar_action--auto_width {
  ::v-deep {
    .bl-nav-bar-large__item-action-set,
    .bl-nav-bar-large__item-action-set span,
    .bl-nav-bar__item-action-set {
      max-width: unset;
    }
  }
}
</style>
